export default "__VITE_ASSET__3fb1d866__"